import { useEffect, useRef } from 'react';
import { Send } from 'lucide-react';
import Button from '../../../components/ui/Button';

interface Props {
  value: string;
  onChange: (v: string) => void;
  onSend: () => void;
  disabled?: boolean;
  placeholder?: string;
}

const MAX_LEN = 4000;

export default function ComposerInput({
  value,
  onChange,
  onSend,
  disabled,
  placeholder = 'Ask a question about your knowledge graph…',
}: Props) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const ta = ref.current;
    if (!ta) return;
    ta.style.height = 'auto';
    ta.style.height = `${Math.min(ta.scrollHeight, 200)}px`;
  }, [value]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!disabled && value.trim()) onSend();
    }
  };

  return (
    <div className="flex-shrink-0 border-t border-neutral-200 bg-white px-4 md:px-6 py-3">
      <div className="max-w-3xl mx-auto flex gap-2 items-end">
        <textarea
          ref={ref}
          value={value}
          onChange={(e) => onChange(e.target.value.slice(0, MAX_LEN))}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={disabled}
          rows={1}
          aria-label="Message"
          className="flex-1 px-4 py-3 border border-neutral-300 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent resize-none disabled:bg-neutral-100 disabled:cursor-not-allowed text-sm placeholder:text-neutral-400"
          style={{ minHeight: 48 }}
        />
        <Button
          onClick={onSend}
          disabled={disabled || !value.trim()}
          size="lg"
          className="px-5 self-end"
        >
          <Send className="w-4 h-4" />
          Send
        </Button>
      </div>
      <p className="text-[11px] text-neutral-500 text-center mt-1.5">
        Enter to send · Shift+Enter for new line · {value.length}/{MAX_LEN}
      </p>
    </div>
  );
}
